import { Menu as AntdMenu } from 'antd'
import {
  MenuDividerProps,
  MenuItemGroupProps,
  MenuItemProps,
  MenuProps,
  MenuRef,
  MenuTheme,
  SubMenuProps
} from 'antd/es/menu'
import { ItemType, MenuItemGroupType } from 'antd/es/menu/interface'
import cx from 'classnames'
import React from 'react'
import './styles.scss'

export type {
  MenuDividerProps,
  MenuItemGroupProps,
  MenuItemGroupType,
  MenuItemProps,
  ItemType as MenuItemType,
  MenuProps,
  MenuRef,
  MenuTheme,
  SubMenuProps
}

export interface AppMenuProps extends MenuProps {
  spacing?: 'small' | 'small-2' | 'medium' | 'large'
  /**
   * If it's a secondary menu we will change the menu highlight
   * color so it doesn't clash with the main menu accent color
   */
  secondary?: boolean
}

export type MenuComponent = React.ForwardRefExoticComponent<AppMenuProps & React.RefAttributes<MenuRef>>

/**
 * This class is a wrap around [antd Menu](https://ant.design/components/menu/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */
export const Menu = React.forwardRef<MenuRef, AppMenuProps>(
  ({ children, className, spacing = 'large', secondary = false, ...props }: AppMenuProps, ref) => (
    <AntdMenu
      ref={ref}
      className={cx('app-menu', `app-menu-spacing--${spacing}`, secondary && 'app-menu--secondary', className)}
      {...props}
    >
      {children}
    </AntdMenu>
  )
) as MenuComponent
Menu.displayName = 'Menu'

export default Menu
